import { AlertMetadata } from './alert-metadata.interface';
import { IAuditableOutputDto } from './auditable-output-dto.interface';
import { AlertTypesEnum } from '../enums';

export interface IAlertTripVehicleOutputDto {
    id: string;
    licensePlate: string;
    name?: string;
}

export interface IAlertTripDriverOutputDto {
    id: string;
    fullName: string;
}

export interface IAlertTripOutputDto {
    id: string;
    tripCode: string;
}

export interface IAlertCarrierOutputDto {
    id: string;
    name: string;
}

export interface IAlertOutputDto {
    id?: string;
    sequenceId?: number;
    organizationId?: string;
    type: AlertTypesEnum;
    trip?: IAlertTripOutputDto;
    stepName: string;
    source: string;
    auditable: IAuditableOutputDto;
    createdAt?: string;
    updatedAt?: string;
    vehicle?: string | IAlertTripVehicleOutputDto;
    driver?: IAlertTripDriverOutputDto;
    carrier?: IAlertCarrierOutputDto;
    metadata?: AlertMetadata;
}

export interface IAlertCarrierOutputDto {
    id: string;
    name: string;
}
